import './footer.css';
import { useState, useEffect } from "react";
import { config } from '../../config/AppConfig';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [snsMessage, setSnsMessage] = useState<number>(1);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setSnsMessage(0);
    }, 8000);
    return () => clearInterval(intervalId); 
  }, []); 

  const [contactList, setContactList] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false); // ローディング状態の管理

  const openContactWeb = () => {
    setContactList((prev) => (prev === 1 ? 0 : 1));
  };

  const [userCompany, setUserCompany] = useState<string>("");
  const [userName, setUserName] = useState<string>("");
  const [userKana, setUserKana] = useState<string>("");
  const [userEmail, setUserEmail] = useState<string>("");
  const [userPhone, setUserPhone] = useState<string>("");
  const [userQuestion, setUserQuestion] = useState<string>("");
  const [selectedOption, setSelectedOption] = useState<string>('一般的なお問い合わせ');

  const handleContact = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    // 必須フィールドのチェック
    if (!userName || !userEmail) {
      alert('氏名とメールアドレスは必須です。');
      return; // フォーム送信を中止
    }

    const formData = {
      userCompany,
      userName,
      userKana,
      userEmail,
      userPhone,
      userQuestion,
      selectedOption,
    };

    const url = `${config.apiUrl}/contact`;
    setLoading(true); // ローディング開始

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
      
      if (response.ok) {
        alert('お問い合わせを受け付けました。');
        setContactList(0); // フォームを閉じる（オプション）
      } else {
        alert('送信に失敗しました。もう一度お試しください。');
      }
    } catch (error) {
      console.error('Error during fetch:', error);
      alert('送信に失敗しました。もう一度お試しください。');
    } finally {
      setUserCompany("");
      setUserName("");
      setUserKana("");
      setUserEmail("");
      setUserPhone("");
      setUserQuestion("");
      setSelectedOption('一般的なお問い合わせ');
      setContactList(0);
      setLoading(false); // ローディング終了
    }
  };

  return (
    <>
      <footer>
        <div className='footer-item-box'>  
          {contactList === 1 && (
            <div className='contact-web'>
              <div className='contact-title'>
                <h4>お問い合わせ</h4>
              </div>
              <form className="contact-form" noValidate onSubmit={handleContact}>
                <select value={selectedOption} onChange={(e) => setSelectedOption(e.target.value)}>
                  <option value="一般的なお問い合わせ">一般的なお問い合わせ</option>
                  <option value="商品に関するお問い合わせ">商品に関するお問い合わせ</option>
                  <option value="OEMに関するお問い合わせ">OEMに関するお問い合わせ</option>
                  <option value="採用に関するお問い合わせ">採用に関するお問い合わせ</option>
                </select>
                <input type="text" placeholder='会社名'
                  value={userCompany}
                  onChange={(e) => setUserCompany(e.target.value)}
                />
                <input type="text" placeholder='氏名'
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  required // 追加
                />
                <input type="text" placeholder='フリガナ'
                  value={userKana}
                  onChange={(e) => setUserKana(e.target.value)}
                />
                <input type="email" placeholder='メールアドレス'
                  value={userEmail}
                  onChange={(e) => setUserEmail(e.target.value)}
                  required // 追加
                />
                <input type="text" placeholder='電話番号'
                  value={userPhone}
                  onChange={(e) => setUserPhone(e.target.value)}
                />
                <textarea
                  placeholder='お問合せ内容'
                  value={userQuestion}
                  onChange={(e) => setUserQuestion(e.target.value)}
                />
                <div className='contact-btn-box'>
                  <div className='close-btn' onClick={openContactWeb}>
                    <p>閉じる</p>
                  </div>
                  <button type="submit" className='contact-btn' disabled={loading}>
                    {loading ? '送信中...' : '送信する'}
                  </button>
                </div>
              </form>
            </div>
          )} 
          <div className='copy-right'>
            <div className='sns-btn'>
              <a href="https://www.instagram.com/nomuraseisakusho_official/" target="_blank" rel="noopener noreferrer">
                <img src='img/instagram.png' alt='instagram'/>
              </a>
              <a href="https://www.facebook.com/nomuraseisakusho/" target="_blank" rel="noopener noreferrer">
                <img src='img/facebook.png' alt='facebook'/>
              </a>
              <a href="https://x.com/nomurass_jp" target="_blank" rel="noopener noreferrer">
                <img src='img/twitter_x.png' alt='twitter_x'/>
              </a>
            </div>
            <p>Copyright © {currentYear} NOMURA SEISAKUSHO CO., LTD</p>
            <div className='contact-show-btn' onClick={openContactWeb}>
              <img src='img/help.png' alt='help'/>
              <p>お問い合わせ</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
